import { CountryCode } from '@gql/graphql';

export const POPULAR_BREEDS: Record<CountryCode, number[]> = {
  [CountryCode.BE]: [11355, 11344, 11440, 11387, 11329, 11448, 11699, 11347],
  [CountryCode.EU]: [11355, 11344, 11440, 11387, 11329, 11448, 11699, 11347],
  [CountryCode.FR]: [11329, 11440, 11457, 11355, 11311, 11448, 11344, 11347],
  [CountryCode.CA]: [],
  [CountryCode.CH]: [],
  [CountryCode.NL]: [11505, 11355, 11453, 11687, 11329, 11340, 11356, 11374],
  [CountryCode.DE]: [11505, 11461, 11329, 11389, 11597, 11506, 11474, 11355],
};

export const ADDITIONAL_POPULAR_BREEDS: Record<CountryCode, number[]> = {
  [CountryCode.BE]: [
    11488, 11687, 11457, 11340, 11596, 11425, 11584, 11372, 11361, 11623, 11311, 11320, 11570,
    11593, 11401, 11379,
  ],
  [CountryCode.EU]: [
    11488, 11687, 11457, 11340, 11596, 11425, 11584, 11372, 11361, 11623, 11311, 11320, 11570,
    11593, 11401, 11379,
  ],
  [CountryCode.FR]: [
    11320, 11425, 11453, 11622, 11372, 11345, 11387, 11699, 11310, 11584, 11596, 11610, 11432,
    11340, 11338, 11401,
  ],
  [CountryCode.CA]: [],
  [CountryCode.CH]: [],
  [CountryCode.NL]: [
    11661, 11646, 11461, 11570, 11699, 11709, 11355, 11367, 11463, 11544, 11546, 11311, 11320,
    11429, 11347, 11367,
  ],
  [CountryCode.DE]: [
    11593, 11405, 11440, 11570, 11781, 11374, 11387, 11411, 11708, 11453, 11457, 11566, 11455,
    11483, 11523, 11527,
  ],
};

// BE
/*
border collie - 1 = 11355
malinois - 2 = 11344
bouledogue français - 3 = 11440
chihuahua - 4 = 11387
berger australien - 7 = 11329
berger allemand - 9 = 11448
american bully - 12 = 11699
bouvier bernois - 13 = 11347

jack russell terrier- 8 = 11488
berger blanc suisse - 10 = 11687
golden retriever - 14 = 11457
beauceron - 15 = 11340
rottweiler - 17 = 11596
cocker spaniel anglais - 20 = 11425
carlin - 21 = 11584
bulldog anglais - 22 = 11372
boxer - 23 = 11361
shih tzu - 24 = 11623
husky - 25 = 11311
american staff - 26 = 11320
caniche - 27 = 11570
rhodesian ridgeback - 29 = 11593
teckel - 32 = 11401
cane corso - 35 = 11379
dogue allemand - 41 = 11461


// FR

berger australien - 1 = 11329
bouledogue français - 3 = 11440
golden retriever - 4 = 11457
border collie - 7 = 11355
husky - 9 = 11311
berger allemand - 11 = 11448
malinois - 13 = 11344
bouvier bernois - 14 = 11347

american staff - 2 = 11320
cocker spaniel anglais - 5 = 11425
spitz nain - 12 = 11453
shiba inu - 16 = 11622
bulldog anglais - 17 = 11372
berger belge tervueren - 18 = 11345
chihuahua - 18 = 11387
american bully - 22 = 11699
akita - 24 = 11310
carlin - 27 = 11584
rottweiler - 28 = 11596
samoyède - 29 = 11610
eurasier - 30 - 11432
beauceron - 31 = 11340
beagle - 46 = 11338
teckel - 48 = 11401

*/
